import { render, staticRenderFns } from "./dashboard-area-chart.vue?vue&type=template&id=0075b66a&scoped=true&"
import script from "./dashboard-area-chart.vue?vue&type=script&lang=js&"
export * from "./dashboard-area-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0075b66a",
  null
  
)

export default component.exports